import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const videoPlayerV3PaddingToMarginMigration: PropsMigration = {
  mode: 'props',
  description: 'Migrate video player external spacing from offset.padding to offset.margin',
  run: (props: PartialPropsOf<'videoPlayer'>): void => {
    const offset = props.style?.video?.offset;
    if (offset?.padding === undefined) {
      return;
    }
    offset.margin = offset.padding;
    delete offset.padding;
  },
};
